export default "__VITE_ASSET__moZ28SOb__"